<template>
  <v-card class="mb-2 pa-1">
    <v-card-title class="mb-message py-0">
      <span class="caption" v-if="message.topicSubject">
        Assunto: <b> {{ message.topicSubject }} </b> - {{ message.orderIdMarketplace }}
      </span>
      <v-spacer></v-spacer>
      <span class="caption font-weight-light">#{{ index + 1}}</span>
      <v-icon small right>
        mdi-message
      </v-icon>
    </v-card-title>
    <v-card-text class="py-5">
      <div v-html="message.messageBody"></div>
    </v-card-text>
    <v-card-actions class="caption font-weight-light text-right mt-message  py-0">
      <v-spacer></v-spacer>
      <i
        >Por: <b>{{ message.idUser }}</b> em {{ message.messageCreation | formatFullDate }} </i
      ><br />
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    message: Object,
    index: Number,
  },
}
</script>

<style></style>
